/*
  Mandatory params :

      @param photosDatas {object} (mandatory), //Example : { '362x160': ["url-1.jpg", "url-2.jpg"], '400x400': ["url-1.jpg", "url-2.jpg"], etc... }
      @param resolutionToUse {object} (mandatory), //Example : { desktop: '620x274', tablet: '400x400', mobile: '362x160' }
      @param productCode {string} (mandatory), Example : "BF"

  Optionnal params :

      @param openPopinOnClick {object} (optional), Default = { desktop: true, tablet: true, mobile: true }
      @param housingCode {string} (optional), Default = '', Example : "BF125"

  If housingCode is set, then this slider is for a housing, otherwise it is a domain
*/
/**
 *
 * @param params
 * @return {string}
 */
const sliderPhotosTpl = function (params) {
  let template = '';
  // Check mandatory params definition
  if (typeof params === 'object' && Object.keys(params).length) {
    if (typeof params.photosDatas === 'object' && Object.keys(params.photosDatas).length) {
      if (typeof params.resolutionToUse === 'object' && Object.keys(params.resolutionToUse).length) {
        if (typeof params.productCode === 'string' && params.productCode.length) {
          const hasVideo = typeof params.videoDatas === 'object' && Object.keys(params.videoDatas).length;
          const virtualTour = params.virtualTour ? params.virtualTour[GLOBAL_SCRIPTS.MARKET_LANGUAGE] : '';

          // Set Optionnal params default values
          const openPopinOnClick = typeof params.openPopinOnClick === 'object' && Object.keys(params.openPopinOnClick).length ? params.openPopinOnClick : {
            desktop: true,
            tablet: true,
            mobile: true
          };

          // Construction of images urls by device type
          const imagesArray_desktop = typeof params.photosDatas[params.resolutionToUse.desktop] !== 'undefined' ? params.photosDatas[params.resolutionToUse.desktop] : [];
          const imagesArray_tablet = typeof params.photosDatas[params.resolutionToUse.tablet] !== 'undefined' ? params.photosDatas[params.resolutionToUse.tablet] : [];
          const imagesArray_mobile = typeof params.photosDatas[params.resolutionToUse.mobile] !== 'undefined' ? params.photosDatas[params.resolutionToUse.mobile] : [];

          let imagesLengthMax = Math.max.apply(Math, [imagesArray_desktop.length, imagesArray_tablet.length, imagesArray_mobile.length]);
          if (imagesArray_desktop.length < imagesLengthMax) {
            for (let i = 0; i < imagesLengthMax; i++) {
              imagesArray_desktop.push(GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/' + params.resolutionToUse.desktop + '.jpg');
            }
          }
          if (imagesArray_tablet.length < imagesLengthMax) {
            for (let i = 0; i < imagesLengthMax; i++) {
              imagesArray_tablet.push(GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/' + params.resolutionToUse.tablet + '.jpg');
            }
          }
          if (imagesArray_mobile.length < imagesLengthMax) {
            for (let i = 0; i < imagesLengthMax; i++) {
              imagesArray_mobile.push(GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/' + params.resolutionToUse.mobile + '.jpg');
            }
          }

          const gaAction = typeof params.housingCode === 'string' ? 'block cottage' : 'block park';
          let trackLeftArrow = '';
          let trackRightArrow = '';

          if (typeof params.arrowTracking !== 'undefined') {
            trackLeftArrow = params.arrowTracking;
            trackRightArrow = params.arrowTracking;
          } else {
            trackLeftArrow = '{"popinName":"galleryPhotos","event":"clickEvent","actionCode":"clickAccommodationGalleryArrow","gaCategory":"' + PAGE_SCRIPTS.page_template + '","gaAction":"' + gaAction + '","gaLabel":"left arrow","gaValue":1, "popinContainsFormsInfos":false}';
            trackRightArrow = trackLeftArrow.replace('left', 'right');
          }

          // Duplicate first image if only one picture and virtual tour is present
          if (virtualTour !== '' && imagesLengthMax === 1) {
            imagesArray_desktop.push(imagesArray_desktop[0]);
            imagesArray_tablet.push(imagesArray_tablet[0]);
            imagesArray_mobile.push(imagesArray_mobile[0]);
            imagesLengthMax++;
          }

          template += `
<div class="sliderPhotos js-sliderPhotos swiper-container isFirstPhoto${params.toInit ? ' toInit' : ''}" data-open-popin-desktop="${openPopinOnClick.desktop}" data-open-popin-tablet="${openPopinOnClick.tablet}" data-open-popin-mobile="${openPopinOnClick.mobile}" data-resolution-desktop="${params.resolutionToUse.desktop}" data-resolution-tablet="${params.resolutionToUse.tablet}" data-resolution-mobile="${params.resolutionToUse.mobile}">
  <div class="sliderPhotos-slider swiper js-sliderPhotos-slider" init="false">
    <div class="swiper-wrapper">`;
          for (let i = 0; i < imagesLengthMax; i++) {
            // Funny part: Loop through all images and build slider's markup
            template += `
      <div class="sliderPhotos-slide swiper-slide">
        <div class="sliderPhotos-picture">
          ${hasVideo && i === 0 ? `
          <a href="#" class="popinActivity-video js-fancybox-video" data-url="${params.videoDatas[0]}" data-type="videoLink">
            <i class="icon icon-play"></i>` : ''}
            <img width="${DEVICE.isDesktop ? params.resolutionToUse.desktop.split('x')[0] : DEVICE.isTablet ? params.resolutionToUse.tablet.split('x')[0] : params.resolutionToUse.mobile.split('x')[0]}" height="${DEVICE.isDesktop ? params.resolutionToUse.desktop.split('x')[1] : DEVICE.isTablet ? params.resolutionToUse.tablet.split('x')[1] : params.resolutionToUse.mobile.split('x')[1]}" class="js-openPopinOnClick lazy sliderPhotos-img${openPopinOnClick.desktop || openPopinOnClick.tablet || openPopinOnClick.mobile ? ' js-Tracking--link' : ''}" data-url-desktop="${imagesArray_desktop[i]}" data-url-tablet="${imagesArray_tablet[i]}" data-url-mobile="${imagesArray_mobile[i]}"${openPopinOnClick.desktop || openPopinOnClick.tablet || openPopinOnClick.mobile ? ` data-tracking='{"popinName":"galleryPhotos","actionCode":"clickAccommodationImage","gaCategory":"${PAGE_SCRIPTS.page_template}","gaAction":"Accommodation open gallery destination ${gaAction}","gaLabel":"Image","gaValue":1, "popinContainsFormsInfos":false}' data-code="${params.productCode}" data-brand="${params.brandCode}"${typeof params.housingCode === 'string' ? ` data-housingcode="${params.housingCode}"` : ''}` : ''}>
          ${hasVideo && i === 0 ? `
          </a>` : ''}
          ${virtualTour !== '' && i === imagesLengthMax - 1 ? `
          <a class="sliderPhotos-virtualTour-slide js-showVirtualTour" data-url="${virtualTour}">
            <span class="button button--whiteBlack icon icon-360">${GLOBAL_SCRIPTS.WORDINGS_COMMON.virtualTour}</span>
          </a>` : ''}
        </div>
      </div>`;
          }
          template += `
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
  <span class="sliderPhotos-buttons">
    <span class="sliderPhotos-counter">
      <span class="sliderPhotos-counter__icon icon icon-tabs"></span>
      <span class="sliderPhotos-counter__txt">
        <span class="js-sliderPhotos-total-count">${imagesLengthMax}</span>
      </span>
    </span>
    ${virtualTour !== '' ? `
    <span class="sliderPhotos-virtualTour icon icon-360 js-goToLastSlide"></span>` : ''}
  </span>
</div>`;
        }
      }
    }
  }

  return template;
};

export {sliderPhotosTpl};